import { GetterTree } from 'vuex'
import { MailTemplatesState, MailTemplate } from '@/store/mails/templates/types'
import { RootState } from '@/store/types'
import _ from 'lodash'

const getters : GetterTree<MailTemplatesState, RootState> = {
  /**
   * メールテンプレートidを元にメールテンプレート情報を取得する
   * @param {string} id メールテンプレートid
   */
  findMailTemplateById: (state) => (id: string): MailTemplate => _.chain(state.templates)
    .find({ id })
    .cloneDeep()
    .value(),
}

export default getters
